import {
	type EventTypesCreateEventTypeBodyLocale,
	getEventTypesListEventTypesQueryKey,
	useEventTypesCreateEventType,
} from '@cocoonspace/api'
import { useLingui } from '@lingui/react/macro'
import { useQueryClient } from '@tanstack/react-query'
import slugify from 'slugify'
import { toast } from 'sonner'

import { type EditEventTypeFormData, EventTypeForm } from './event-type-form'

const defaultValues: Partial<EditEventTypeFormData> = {
	duration: 30,
	availabilities: {
		mon: [{ startTime: '09:00', endTime: '17:00' }],
		tue: [{ startTime: '09:00', endTime: '17:00' }],
		wed: [{ startTime: '09:00', endTime: '17:00' }],
		thu: [{ startTime: '09:00', endTime: '17:00' }],
		fri: [{ startTime: '09:00', endTime: '17:00' }],
		sat: [],
		sun: [],
	},
	bookingWindow: {
		start: 'P7D',
		end: 'P2M',
	},
}

export const CreateEventType = ({
	onSuccess,
	defaultValues: overrideDefaultValues,
}: {
	onSuccess?: VoidFunction
	defaultValues?: Partial<EditEventTypeFormData>
}) => {
	const { t } = useLingui()
	const createEventTypeMutation = useEventTypesCreateEventType()
	const queryClient = useQueryClient()

	const handleSubmit = async (data: EditEventTypeFormData) => {
		return createEventTypeMutation
			.mutateAsync({
				data: {
					...data,
					slug: slugify(data.title),
					timezone: 'Europe/Paris',
					locale: data.locale as EventTypesCreateEventTypeBodyLocale,
				},
			})
			.then(() => {
				toast.success(t`Type de rendez-vous créé`)

				queryClient.invalidateQueries({
					queryKey: getEventTypesListEventTypesQueryKey(),
				})

				onSuccess?.()
			})
	}

	return (
		<EventTypeForm
			isLoading={createEventTypeMutation.isPending}
			defaultValues={{ ...defaultValues, ...overrideDefaultValues }}
			allowPristineSubmit={!!overrideDefaultValues}
			onSubmit={handleSubmit}
		/>
	)
}
